export default __webpack_public_path__ + "static/media/chevron_left_white_48dp.66dc9ac8.svg";